<script>

export default {
    props: {
        label: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            default: 0
        },
        alternative: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            required: true
        },
        error: {
            type: Boolean,
            required: true
        },
        noContent: {
            type: Boolean,
            required: true
        }
    }
}
</script>
<template>
    <div :class="{'stat-number--alternative': alternative}"
         class="stat-number">
        <transition name="fade" mode="out-in">
            <div v-if="!loading && !error && !noContent"
                 :key="'success'"
                 class="stat-number__body">
                <div class="stat-number__label">{{ label }}</div>
                <div class="stat-number__value">{{ $shortNumber(value) }}</div>
                <div class="stat-number__subtitle">{{ subtitle }}</div>
            </div>
            <div v-if="loading"
                 :key="'loading'"
                 class="stat-number__body">
                <div class="stat-number__fake-label"/>
                <div class="stat-number__fake-value"/>
                <div class="stat-number__fake-subtitle"/>
            </div>
            <div v-if="error && !loading"
                 :key="'failed'"
                 class="stat-number__body">
                <div class="stat-number__error-label">
                    {{ label }}
                </div>
                <div class="stat-number__error-icon">
                    <i class="fa fa-fw fa-exclamation-triangle"/>
                </div>
                <div class="stat-number__error-message">
                    {{ $t('statNumber.body.failedToFetchData') }}
                </div>
            </div>
            <div v-if="noContent && !loading"
                 :key="'noContent'"
                 class="stat-number__body">
                <div class="stat-number__error-label">
                    {{ label }}
                </div>
                <div class="stat-number__error-icon">
                    <i class="fa fa-fw fa-exclamation-triangle"/>
                </div>
                <div class="stat-number__error-message">
                    {{ $t('statNumber.body.noDataFound') }}
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatNumber/StatNumber.vue